import { render, staticRenderFns } from "./CambioBobina.vue?vue&type=template&id=2389cba3&scoped=true&"
import script from "./CambioBobina.vue?vue&type=script&lang=js&"
export * from "./CambioBobina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2389cba3",
  null
  
)

export default component.exports